import { Observable, BehaviorSubject } from "rxjs";
import {
  Component,
  HostListener,
  OnInit,
  ViewChild,
  ChangeDetectorRef,
  Inject,
  EventEmitter,
  Output,
  Input,
  ViewEncapsulation,
  ElementRef,
  Renderer2,
} from "@angular/core";
import { PoolService } from "src/app/services/pool.service";
import { AuthService } from "../../services/auth.service";
import { ParamService } from "src/app/services/param.service";
import { ListComponent } from "../document/list.component";
import { FormControl } from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
import { STEPPER_GLOBAL_OPTIONS } from "@angular/cdk/stepper";
import { MatExpansionModule } from "@angular/material/expansion";
import { DomSanitizer } from "@angular/platform-browser";
import { MatStepper } from "@angular/material/stepper";
import { MatDialog, MatDialogRef } from "@angular/material/dialog";
import { MatPaginator } from "@angular/material/paginator";
import { MatSnackBar, MatSnackBarConfig } from "@angular/material/snack-bar";
import { MatTableDataSource } from "@angular/material/table";
import { MatSort } from "@angular/material/sort";
import { MatCheckbox } from "@angular/material/checkbox";
import { MAT_DIALOG_DATA } from "@angular/material/dialog";
import { DataSource, SelectionModel } from "@angular/cdk/collections";
import { RemoteWorkSchedulerComponent } from "../../components/remote-work-scheduler/remote-work-scheduler.component";

import {
  MAT_MOMENT_DATE_FORMATS,
  MomentDateAdapter,
} from "@angular/material-moment-adapter";
import {
  DateAdapter,
  MAT_DATE_FORMATS,
  MAT_DATE_LOCALE,
} from "@angular/material/core";

import { formatDate } from "@angular/common";
import moment from "moment";
import { jsPDF } from "jspdf";
import { DialogLeaveDetail } from "./dialog-leave-detail"; // Yeni oluşturacağımız detay componenti

// import pdfmake from 'pdfmake/build/pdfmake';
// import pdfFonts from 'pdfmake/build/vfs_fonts';
// pdfmake.vfs = pdfFonts.pdfMake.vfs;
// const moment = _moment;

export interface Language {
  label: string;
  labelName: string;
}

export interface LanguageMap {
  [key: string]: Language;
}

export interface DailyApproverElement {
  srkodu: string;
  prsicil: string;
  name: string;
  yillikKalan: number;
  yillikFazlaMesai: number;
  neden: string;
  bastarih: Date;
  bassaat: string;
  bitsaat: string;
  sure: string;
  yemekyer: boolean;
  gelis: boolean;
  gidis: boolean;
  gelisservis: boolean;
  gidisservis: boolean;
  gun: string;
  bittarih: Date;
  isbasi: Date;
  id: number;
  sebep: string;
  sebep2: string;
  aciklama: string;
  onay1: boolean;
  onay1kl: string;
  post: boolean;
  ret: boolean;
  amir: boolean;
  amirKodu: string;
}

export interface UserElement {
  id: number;
  companyId: number;
  username: string;
  employee: string;
  name: string;
  donem: number;
  depart: string;
  yemekyer: boolean;
  useServiceArrival: boolean;
  serviceArrival: string;
  useServiceGoing: boolean;
  serviceGoing: string;
  // iostarttime:string,
  // inoutput:string
}

export interface DialogData {
  insert: boolean;
  approve: boolean;
  color: string;
  desc: string;
  auth: string;
}

export const MY_FORMATS = {
  parse: {
    dateInput: "LL",
  },
  display: {
    dateInput: "LL",
    monthYearLabel: "MMM YYYY",
    dateA11yLabel: "LL",
    monthYearA11yLabel: "MMMM YYYY",
  },
};

@Component({
  selector: "app-outofoffice",
  templateUrl: "./outofoffice.component.html",
  styleUrls: ["./outofoffice.component.scss"],

  providers: [
    // {provide: DateAdapter, useClass: OutofofficeComponent},
    { provide: STEPPER_GLOBAL_OPTIONS, useValue: { showError: true } },
    {
      provide: DateAdapter,
      useClass: MomentDateAdapter,
      deps: [MAT_DATE_LOCALE],
    },
    { provide: MAT_DATE_FORMATS, useValue: MY_FORMATS },
  ],
})
export class OutofofficeComponent implements OnInit {
  // isLinear = false;
  public maskTime = [/[0-9]/, /\d/, ":", /\d/, /\d/];
  public isMobile: boolean = false;
  bcsRemoteWorkDays: any[] = [];
  isSuccess: boolean = true;
  statusMessage: string = "İşlem Gerçekleşmiştir.";
  isLoading: boolean = true;
  mainScreenVisible = true;
  firstFormGroup!: FormGroup;
  secondFormGroup!: FormGroup;
  thirdFormGroup!: FormGroup;
  isOptional = false;
  user!: string;
  userType!: string;
  nextBtn = true;
  nextBtnAlert = true;
  formTemplate = "";
  workflow!: string[];
  maxMonthlyLimit: any;
  currentUsedBalance: any;
  // flowName=['Günlük İzin','Saatlik İzin','Mesai','Rapor']
  personelInfo: any = [];
  selectedReason!: string;
  dialogRefTemp: any;
  language: any = [];
  languageMap: LanguageMap = {};
  shiftDates: any = [];
  hiddenOnPrint = true;
  usrlanguages: any = [];
  responseList: any;
  responseTotalList: any;
  printRules: any;
  dayDateChange = "";
  outofofficeCount = 0;
  outofoffice = [
    { id: 0, value: "İzin Seçim", color: "basic", auth: false, matBadge: 0 },
    { id: 1, value: "Günlük İzin", color: "#64748b", auth: false, matBadge: 0 },
    {
      id: 2,
      value: "Saatlik İzin",
      color: "#0d9488",
      auth: false,
      matBadge: 0,
    },
    { id: 3, value: "Fazla Mesai", color: "#ef4444", auth: false, matBadge: 0 },
    { id: 4, value: "Vardiya", color: "#1e293b", auth: false, matBadge: 0 },
    {
      id: 5,
      value: "Hareket Giriş",
      color: "#7c3aed",
      auth: false,
      matBadge: 0,
    },
    { id: 6, value: "", color: "", auth: false, matBadge: 0 },
    { id: 7, value: "", color: "", auth: false, matBadge: 0 },
    { id: 8, value: "Talep Takip", color: "#b45309", auth: false, matBadge: 0 },
    { id: 9, value: "", color: "", auth: false, matBadge: 0 },
    {
      id: 10,
      value: "Evden Çalışma",
      color: "#1e40af",
      auth: false,
      matBadge: 0,
    },
  ];
  approve = false;
  flowIndex: any | undefined = 0;
  reasons: any = [];
  postas: any = [];
  fmservices: any = [];
  giriscikis: any = [
    { kodu: 0, adi: "GİRİŞ" },
    { kodu: 1, adi: "ÇIKIŞ" },
  ];
  firstCtrl = new FormControl();
  chkApprove = new FormControl();
  approver = "";
  prmgecmisPostUser = false;
  prmamir1 = false;
  prmlanguage = "";
  prmfirmName = "";
  prmreportUrl = "";
  prmreportUrlSecure = false;
  prmfmYemek = false;
  prmfmUseForm = false;
  prmsiUseForm = false;
  prmprsBazli = false;
  prmsiSaat = false;
  prmgiUseForm = false;
  prmfmFormOnay = false;
  prmsiFormOnay = false;
  prmgiFormOnay = false;
  formOnay = false;
  prmonayTuru = 0;
  prmfmTip = 0;
  prmfmServis = false;
  prmgiDesc = false;
  prmgiYillikIzin = false;
  prmsiDesc = false;
  prmfmDesc = false;
  prmgiGecmisIslem = 0;
  prmsiGecmisIslem = 0;
  prmfmGecmisIslem = 0;
  prmgiNeden = false;
  prmsiNeden = false;
  prmfmNeden = false;
  prmhktUseForm = false;
  prmhktFormOnay = false;
  prmhktNeden = false;
  prmhktDesc = false;
  prmhktGecmisIslem = false;
  prmhktGecmisIslemSure = 0;
  prmpstDesc = false;
  prmpstGecmisIslem = false;
  prmpstGecmisIslemSure = 0;

  amirApproved = false;
  prmAuth = false;
  prmApproveType = 0;
  prmRet = false;

  pageIndex: number = 0;
  amrState = [
    { id: 1, checked: false, active: false },
    { id: 2, checked: false, active: false },
    { id: 3, checked: false, active: false },
  ];

  usrData: any = [];
  usrDataSource: any;
  usrDisplayedColumns: any;
  usrSelection: any;
  aprDataSource: any;
  aprDisplayedColumns: any;
  amrDataSource: any;
  amrDisplayedColumns: any;
  amrSelection: any;
  @ViewChild("usrPaginator", { static: false }) usrPaginator!: MatPaginator;
  @ViewChild("usrSorter", { static: false }) usrSort!: MatSort;
  @ViewChild("aprPaginator", { static: false }) aprPaginator!: MatPaginator;
  @ViewChild("aprSorter", { static: false }) aprSort!: MatSort;
  @ViewChild("amrPaginator", { static: false }) amrPaginator!: MatPaginator;
  @ViewChild("amrSorter", { static: false }) amrSort!: MatSort;
  @ViewChild("stepper", { static: false }) stepper!: MatStepper;
  @ViewChild("pdfTable", { static: false }) pdfTable!: ElementRef;

  constructor(
    private sanitizer: DomSanitizer,
    private _formBuilder: FormBuilder,
    private AuthService: AuthService,
    private PoolService: PoolService,
    private ParamService: ParamService,
    public dialog: MatDialog,
    private snackBar: MatSnackBar,
    private adapter: DateAdapter<any>,
  ) {}

  @HostListener("window:resize", ["$event"])
  onResize(event: any) {
    this.checkDeviceType();
  }

  lastAction: string = "";

  getUsers(userName: string) {
    this.usrDataSource = [];
    this.usrData = [];
    this.usrDisplayedColumns = [];
    this.PoolService.getPoolUsers(userName, this.userType).subscribe(
      (res: any) => {
        Object.keys(res).forEach((key: any) => {
          this.usrData[key] = res[key];
          this.approver = res[key].approver;
          this.secondFormGroup.patchValue({
            companyId: null,
            starttime: null,
            useYemek: null,
            enddate: null,
            workstartdate: null,
            inoutput: null,
            ioreasonItem: null,
            iodesc: null,
            iostartdate: null,
            iostarttime: null,
            yillikKalan: res[key].yillikKalan,
            yillikFazlaMesai: res[key].yillikFazlaMesai,
            endtime: null,
            useServiceArrival: null,
            useServiceGoing: null,
            arrivalservice: null,
            goingservice: null,
            days: null,
            times: null,
            reasonItem: null,
            postaItem: null,
            reason: null,
            reason2: null,
          });
        });

        this.usrDisplayedColumns = [
          "select",
          "id",
          "employee",
          "name",
          "gorev",
          "yillikFazlaMesai",
          "yillikKalan",
          "departmentId",
        ];
        this.usrDataSource = new MatTableDataSource<UserElement>(this.usrData);
        this.usrDataSource.paginator = this.usrPaginator;
        this.usrDataSource.sort = this.usrSort;
        this.usrSelection = new SelectionModel<UserElement>(false, []);
      },
      (err) => {
        console.log(err);
      },
    );
  }

  get isPersonnelEntryStepVisible(): boolean {
    // 1. Eğer sistem onay/inceleme modundaysa kimse bu adımı görmez
    if (this.approve) {
      return false;
    }

    // 2. Amirler için Vardiya (4) ve PDKS Hareket (5) adımlarını gizle (atla)
    if (
      this.userType === "A" &&
      (this.flowIndex === 4 || this.flowIndex === 5)
    ) {
      return false;
    }

    // 3. Normal personel için veya amirin diğer akışları için bu adım her zaman GÖRÜNÜRDÜR
    return true;
  }

  // İleri butonunun aktif/pasif olma durumunu yöneten merkezi akıllı kontrol
  get isSubmitDisabled(): boolean {
    // Eski TypeScript sürümleri için güvenli null/undefined koruması
    let chkApprove = false;
    if (this.thirdFormGroup && this.thirdFormGroup.value) {
      chkApprove = this.thirdFormGroup.value.chkApprove;
    }

    // Temel kural: Onay kutusu işaretli değilse buton her zaman engellidir
    if (!chkApprove) {
      return true;
    }

    // Akış 1: Günlük İzin Kontrolleri
    if (this.flowIndex === 1) {
      return this.prmgiFormOnay ? !this.formOnay : false;
    }

    // Akış 2: Saatlik İzin Kontrolleri
    if (this.flowIndex === 2) {
      return this.prmsiFormOnay ? !this.formOnay : false;
    }

    // Akış 3: Fazla Mesai Kontrolleri
    if (this.flowIndex === 3) {
      return this.prmfmFormOnay ? !this.formOnay : false;
    }

    // Diğer tüm akışlar (5, 6, 8, 9) için sadece chkApprove kontrolü yeterlidir
    return false;
  }

  rowClick(row: any): void {
    if (this.isMobile) {
      // 📱 MOBİL: Satırın neresine basılırsa basılsın KİBAR POP-UP açılır
      console.log(row);
      this.openDetailDialog(row);
    }
  }

  openDetailDialog(row: any): void {
    const dialogRef = this.dialog.open(DialogLeaveDetail, {
      width: "85%", // Genişliği %90'dan %85'e çektik
      maxWidth: "340px", // Maksimum genişliği 400px'ten 340px'e düşürdük
      height: "auto",
      maxHeight: "80vh", // Ekranın en fazla %80'ini kaplayabilir, taşarsa içinden kayar
      panelClass: "compact-dialog-panel", // Özel CSS sınıfı tanımladık
      data: {
        leaveRecord: row,
        languageMap: this.languageMap,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        for (var i = 0, len = this.amrDataSource.data.length; i < len; i++) {
          if (this.amrDataSource.data[i] == row) {
            this.amrDataSource.data[i].approved = result.approved;
            this.amrDataSource.data[i].rejected = result.rejected;
          }
        }

        if (result.approved) {
          this.stepper.selectedIndex = 1;
          this.approve = true;
          this.nextBtn = true;
          this.addTab();
        }

        if (result.rejected) {
          const dialogRef = this.dialog.open(RejectApprove, {
            width: "350px",
            height: "auto",
            data: {
              // insert: false, approve: false, color: this.outofoffice[item].color, auth: (this.userType === ' ' ? true : false),
              insert: false,
              approve: false,
              auth: this.userType,
              color: this.outofoffice[1].color,
              desc: "",
            },
          });

          dialogRef.afterClosed().subscribe((result) => {
            console.log(result);
            if (result.approve) {
              for (
                var i = 0, len = this.amrDataSource.data.length;
                i < len;
                i++
              ) {
                if (this.amrDataSource.data[i] == row)
                  this.amrDataSource.data[i].retacik = result.desc;
              }
              this.amirApproved = true;
              this.stepper.selectedIndex = 1;
              this.nextBtn = true;
              this.addTab();
            }
          });
        }
      }
    });
  }
  // HTML içindeki karmaşık yazdırma mantığı buraya taşındı
  printFormTemplate(element: any): void {
    console.log(element);
    // Eğer element veya neden alanı boş gelirse koruma kalkanı
    const reasonCode = element.neden ? element.neden.split("-", 1)[0] : "0";

    if (this.flowIndex === 1) {
      this.getFormTemplate({
        user: element.prsicil,
        type: this.flowIndex,
        reason: reasonCode,
        begidate: element.bastarih, // Orijinal koddaki yazım hatasına sadık kalındı (begidate/begindate kontrol edin)
        begindate: element.bastarih,
        enddate: element.bittarih,
        workstartdate: element.workstartdate,
        startdate: element.isbasitarih,
        days: element.gun,
        desc: element.sebep,
        approver: this.approver,
        begintime: "00:00",
        endtime: "00:00",
      });
    } else if (this.flowIndex === 2) {
      this.getFormTemplate({
        user: element.prsicil,
        type: this.flowIndex,
        reason: reasonCode,
        begindate: element.bastarih,
        enddate: element.bastarih,
        startdate: element.bastarih,
        days: 1,
        desc: element.sebep,
        approver: this.approver,
        begintime: element.bassaat,
        endtime: element.bitsaat,
      });
    } else {
      // FlowIndex 3, 5, 6 vb. diğer tüm durumlar için varsayılan çıktı
      this.getFormTemplate({
        user: element.prsicil,
        type: this.flowIndex,
        reason: reasonCode,
        begindate: element.bastarih,
        enddate: element.bastarih,
        startdate: element.bastarih,
        days: 1,
        desc: element.sebep,
        approver: this.approver,
        begintime: element.bassaat,
        endtime: element.bitsaat,
      });
    }
  }

  // HTML içindeki devasa mantığı buraya, ait olduğu yere taşıdık
  getFormTemplateConfig(element: any): any {
    if (this.flowIndex === 1) {
      return {
        user: element.prsicil,
        type: this.flowIndex,
        reason: element.neden ? element.neden.split("-", 1)[0] : "0",
        begindate: element.bastarih,
        enddate: element.bittarih,
        startdate: element.isbasitarih,
        days: element.gun,
        desc: element.sebep,
        approver: this.approver,
        begintime: element.bassaat,
        endtime: element.bitsaat,
      };
    }

    if (this.flowIndex === 2) {
      return {
        user: element.prsicil,
        type: this.flowIndex,
        reason: element.neden ? element.neden.split("-", 1)[0] : "0",
        begindate: element.bastarih,
        enddate: element.bastarih,
        startdate: element.bastarih,
        days: 1,
        desc: element.sebep,
        approver: this.approver,
        begintime: element.bassaat,
        endtime: element.bitsaat,
      };
    }

    if (this.flowIndex === 3) {
      return {
        user: element.prsicil,
        type: this.flowIndex,
        reason: element.neden ? element.neden.split("-", 1)[0] : "0",
        begindate: element.bastarih,
        enddate: element.bastarih,
        startdate: element.bastarih,
        days: 1,
        desc: element.sebep,
        approver: this.approver,
        begintime: element.bassaat,
        endtime: element.bitsaat,
        time: element.sure,
      };
    }

    // Varsayılan Else durumu
    return {
      user: element.prsicil,
      type: this.flowIndex,
      reason: "0",
      begindate: element.bastarih,
      enddate: element.bittarih,
      startdate: element.bastarih,
      days: 1,
      desc: element.sebep,
      approver: this.approver,
      amir: element.amirkodu,
      begintime: element.bassaat,
      endtime: element.bitsaat,
    };
  }

  // Esas işi yapan metodunuzu tetikleyen sarmalayıcı (Eğer template fonksiyonu çalıştırmak gerekiyorsa)
  executeFormTemplate(element: any) {
    console.log(element);
    const config = this.getFormTemplateConfig(element);
    this.getFormTemplate(config); // Orijinal metodunuzu çağırıyoruz
  }

  ngOnInit() {
    // this.usrPaginator._intl.itemsPerPageLabel = 'My translation for items per page.';
    // this.authService.getUserName.subscribe(
    //   goodResult => (this.user = goodResult)
    // );
    // this.authService.getUserType.subscribe(
    //   goodResult => (this.userType = goodResult)
    // );

    // let getUserName$ : Observable<any> = this.authService.getUserName;
    // let getUserType$ : Observable<any> = this.authService.getUserType;
    this.AuthService.getUserName.subscribe(
      (user) => (this.user = user ? user : ""),
    );
    this.AuthService.getUserType.subscribe(
      (userType) => (this.userType = userType ? userType : ""),
    );
    this.getAuth(this.user, this.userType);
    this.getParameters();
    this.turkishCulture();
    this.checkDeviceType();
  }

  private checkDeviceType(): void {
    // 768px ve altı mobil/tablet standardı kabul edilir
    this.isMobile = window.innerWidth <= 768;
  }

  openDefinition() {
    this.dialog
      .open(ListComponent, {
        data: {
          Type: this.flowIndex === 9 ? this.selectedReason : "amir",
          Data: { ID: null, Code: this.user, Name: null },
        },
        disableClose: false,
        width: "600px",
        height: "750px",
      })
      .afterClosed()
      .subscribe((result) => {
        // console.log(result);
        this.secondFormGroup.patchValue({
          amirkodu: result.Code,
          amiradi: result.Name,
        });
      });
  }

  public exportPdf() {
    let pdf = [];
    pdf.push([
      { text: "SicilNo", bold: true },
      { text: "PersonelAdı", bold: true },
    ]);
    this.usrDataSource.data.forEach((element: UserElement) => {
      pdf.push([element["username"], element["name"]]);
    });

    var dd = {
      content: [
        {
          layout: "lightHorizontalLines", // optional
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            // widths: [ '*', 'auto', 100, '*' ],
            headerRows: 1,
            widths: [200, "*"],
            body: pdf,
          },
        },
      ],

      defaultStyle: {
        fontSize: 7,
      },
    };

    const documentDefinition = { content: "PersonelListe" };
    // pdfmake.createPdf(dd).download();
  }

  exportPdfApproves() {
    let pdf = [];
    pdf.push([
      { text: "Onay  Ret", bold: true },
      { text: "Departman", bold: true },
      { text: "SicilNo", bold: true },
      { text: "PersonelAdı", bold: true },
      { text: "Başlangıç", bold: true },
      { text: "Süre", bold: true },
      { text: "Neden", bold: true },
      { text: "Sebep", bold: true },
      { text: "Sebep2", bold: true },
      { text: "aciklama", bold: true },
      { text: "retacik", bold: true },
    ]);

    this.amrDataSource.data.forEach((element: any) => {
      pdf.push([
        element["approved"] ? "Onay" : element["rejected"] > 0 ? "Ret" : "",
        element["departman"],
        element["prsicil"],
        element["name"],
        element["bastarih"],
        element["gun"],
        element["neden"],
        element["sebep"],
        element["sebep2"],
        element["aciklama"],
        element["retacik"],
      ]);
    });

    var dd = {
      content: [
        {
          layout: "lightHorizontalLines", // optional
          table: {
            // headers are automatically repeated if the table spans over multiple pages
            // you can declare how many rows should be treated as headers
            // widths: [ '*', 'auto', 100, '*' ],
            headerRows: 1,
            widths: [
              "*",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
              "auto",
            ],
            body: pdf,
          },
        },
      ],

      defaultStyle: {
        fontSize: 7,
      },
    };

    const documentDefinition = { content: "OnayListe" };
    // pdfmake.createPdf(dd).download();
  }

  indexOfInArray(item: string, array: string[]): number {
    let index: number = -1;
    for (let i = 0; i < array.length; i++) {
      if (array[i] === item) {
        index = i;
      }
    }
    return index;
  }

  getApproveType(item: any) {
    let filterType =
      item == this.languageMap["lblInbox"].labelName
        ? 0
        : item == this.languageMap["lblApproved"].labelName
          ? 1
          : item == this.languageMap["lblRejected"].labelName
            ? 2
            : 0;
    this.prmApproveType = filterType;
    this.amrGetApproveInfo(
      this.user,
      this.prmonayTuru,
      this.flowIndex,
      filterType,
    );
  }

  openReport() {
    console.log(this.prmreportUrlSecure);
    if (this.prmreportUrlSecure) this.openReportUrlSecure();
    else this.openReportUrl();
  }

  openReportUrl() {
    let config = new MatSnackBarConfig();
    config.panelClass = ["message-position"];
    this.snackBar.open(
      this.languageMap["PROCESS_IN_PROGRESS"].labelName,
      "",
      config,
    );
    // this.prmreportUrl="192.168.205.21:2001";
    let obj: any = { UserName: this.user, Password: "1" };
    this.PoolService.openReportUrl(
      "http://" + this.prmreportUrl + "/Login",
      obj,
    ).subscribe(
      (res) => {
        // this.prmreportUrl="www.google.com";

        window.open("http://" + this.prmreportUrl + "/Home/Index/" + res);
        this.snackBar.dismiss();
      },
      (err) => {
        this.snackBar.dismiss();
        let config = new MatSnackBarConfig();
        config.panelClass = ["message-position"];
        config.duration = 3000;
        this.snackBar.open(err.sebep, "", config);
      },
    );
  }

  openReportUrlSecure() {
    let config = new MatSnackBarConfig();
    config.panelClass = ["message-position"];
    this.snackBar.open(
      this.languageMap["PROCESS_IN_PROGRESS"].labelName,
      "",
      config,
    );
    // this.prmreportUrl="192.168.205.21:2001";
    let obj: any = { UserName: this.user, Password: "1" };
    // 'http://' +  kiğili secure sorun yarattı kaldırdık...
    this.PoolService.openReportUrl(
      "https://" + this.prmreportUrl + "/Login",
      obj,
    ).subscribe(
      (res) => {
        // this.prmreportUrl="www.google.com";
        // '//' + ---?????
        window.open("https://" + this.prmreportUrl + "/Home/Index/" + res);
        this.snackBar.dismiss();
      },
      (err) => {
        this.snackBar.dismiss();
        let config = new MatSnackBarConfig();
        config.panelClass = ["message-position"];
        config.duration = 3000;
        this.snackBar.open(err.sebep, "", config);
      },
    );
  }

  onApproveHeaderChange(event: any, state: any) {
    this.amirApproved = false;
    for (var i = 0, len = this.amrState.length; i < len; i++) {
      if (this.amrState[i].id === state) {
        if (state === 2) {
          if (event.checked) {
            const dialogRef = this.dialog.open(RejectApprove, {
              width: "350px",
              height: "auto",
              data: {
                insert: false,
                approve: false,
                auth: this.userType,
                color: this.outofoffice[1].color,
                desc: "",
              },
              panelClass: "my-dialog-container-class",
            });

            dialogRef.afterClosed().subscribe((result) => {
              if (result.approve) {
                for (
                  var j = 0, len1 = this.amrDataSource.data.length;
                  j < len1;
                  j++
                ) {
                  this.amrDataSource.data[j].retacik = result.desc;
                }
                this.amirApproved = true;
              }
            });
          } else {
            for (
              var j = 0, len1 = this.amrDataSource.data.length;
              j < len1;
              j++
            ) {
              this.amrDataSource.data[j].retacik = "";
            }
          }
        }

        this.amrState[i].checked = event.checked;
        this.amrState[i].active = true;

        this.nextBtn = event.checked;
        for (var j = 0, len1 = this.amrDataSource.data.length; j < len1; j++) {
          this.amrDataSource.data[j].approved = false;
          this.amrDataSource.data[j].rejected = false;
          this.amrDataSource.data[j].wait = false;
        }

        for (var j = 0, len1 = this.amrDataSource.data.length; j < len1; j++) {
          if (this.amrState[i].id === 1) {
            this.amrDataSource.data[j].approved = event.checked;
            if (event.checked) this.amirApproved = true;
          }
          if (this.amrState[i].id === 2) {
            this.amrDataSource.data[j].rejected = event.checked;
            if (event.checked) this.amirApproved = true;
          }
          if (this.amrState[i].id === 3) {
            this.amrDataSource.data[j].wait = event.checked;
            if (event.checked) this.amirApproved = true;
          }
        }
      } else {
        this.amrState[i].checked = false;
        this.amrState[i].active = false;
      }
    }
  }

  onApproveDetailChange(row: any, state: any, e: any) {
    this.amirApproved = false;
    this.nextBtn = e.checked;
    if (state === 1) {
      row.approved = true;
      row.rejected = false;
      row.wait = false;
      if (e.checked) {
        this.amirApproved = true;
      }
    }
    if (state === 2) {
      row.rejected = true;
      row.approved = false;
      row.wait = false;
      if (e.checked) {
        const dialogRef = this.dialog.open(RejectApprove, {
          width: "350px",
          height: "auto",
          data: {
            // insert: false, approve: false, color: this.outofoffice[item].color, auth: (this.userType === ' ' ? true : false),
            insert: false,
            approve: false,
            auth: this.userType,
            color: this.outofoffice[1].color,
            desc: "",
          },
        });

        dialogRef.afterClosed().subscribe((result) => {
          if (result.approve) {
            for (
              var i = 0, len = this.amrDataSource.data.length;
              i < len;
              i++
            ) {
              if (this.amrDataSource.data[i] == row)
                this.amrDataSource.data[i].retacik = result.desc;
            }
            this.amirApproved = true;
          }
        });
      } else {
        for (var i = 0, len = this.amrDataSource.data.length; i < len; i++) {
          if (this.amrDataSource.data[i] == row)
            this.amrDataSource.data[i].retacik = "";
        }
      }
    }
    if (state === 3) {
      row.wait = true;
      row.rejected = false;
      row.approved = false;
    }
  }

  getReason(user: any, flowIndex: any) {
    this.PoolService.getReasons(flowIndex).subscribe(
      (res) => {
        this.reasons = res;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  getPosta() {
    this.PoolService.getPosta().subscribe(
      (res) => {
        this.postas = res;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  SetPersonelServices(id: any, event: any) {
    if (id === "chkarrival")
      if (event.checked)
        this.secondFormGroup.patchValue({
          arrivalservice: this.fmservices.filter(
            (item: any) => item.username === this.user,
          )[0].kodu,
        });
      else this.secondFormGroup.patchValue({ arrivalservice: "" });

    if (id === "chkgoing")
      if (event.checked)
        this.secondFormGroup.patchValue({
          goingservice: this.fmservices.filter(
            (item: any) => item.username === this.user,
          )[0].kodu,
        });
      else this.secondFormGroup.patchValue({ goingservice: "" });
  }

  getFMServiceItems(chk: any) {
    // this.secondFormGroup.patchValue({ arrivalservice: deneme });
    return this.fmservices; //.filter((item) => item.username === username);//.filter((item) => item.type === type);
  }

  getFMService(user: any) {
    this.PoolService.getFMServices(user).subscribe(
      (res) => {
        this.fmservices = res;
      },
      (err) => {
        console.log(err);
      },
    );
  }

  turkishCulture() {
    this.adapter.setLocale("tr");
  }

  applyApproveFilter(filterValue: string) {
    this.amrDataSource.filter = filterValue.trim().toLocaleUpperCase();
  }

  applyFilter(filterValue: string) {
    this.usrDataSource.filter = filterValue.trim().toLocaleUpperCase();
  }

  //   async delay(ms: number) {
  //     await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>

  //     (this.amrGetApproveInfo(this.user,this.prmonayTuru, null))
  //     );
  // }

  // async delay(ms: number) {
  //   await new Promise(resolve => setTimeout(resolve, ms)).then(() =>
  //     this.print());
  // }

  getLanguage(lng: any) {
    let data;
    this.ParamService.getLanguageInfo().subscribe(
      (res: any) => {
        Object.keys(res).forEach((key) => {
          let data = { label: res[key].label, labelName: res[key].labelName };
          this.language.push(data);
        });

        // let languageMap: LanguageMap = {};
        this.language.forEach((s: Language) => {
          this.languageMap[s.label] = s;
        });

        this.outofoffice[1].value = this.languageMap["lblDaily"].labelName;
        this.outofoffice[2].value = this.languageMap["lblHourly"].labelName;
        this.outofoffice[3].value = this.languageMap["lblFM"].labelName;
        this.outofoffice[4].value = this.languageMap["lblShift"].labelName;
        this.outofoffice[5].value = this.languageMap["lblIO"].labelName;
        this.outofoffice[6].value = this.languageMap["lblPosta"].labelName;
        this.outofoffice[7].value = this.languageMap["lblReports"].labelName;
        this.outofoffice[8].value =
          this.languageMap["lblApprovalTrack"].labelName;
        this.outofoffice[10].value =
          this.languageMap["lblRemoteWork"].labelName;

        this.workflow = new Array();
        this.workflow.push(this.languageMap["lblApproved"].labelName);
        this.workflow.push(this.languageMap["lblRejected"].labelName);
        this.workflow.push(this.languageMap["lblInbox"].labelName);
        // console.log(this.workflow);

        // console.log(this.language);
      },
      (err) => {
        console.log(err);
      },
    );
  }

  getParameters() {
    this.ParamService.getParameters().subscribe(
      (res: any) => {
        Object.keys(res).forEach((key: any) => {
          this.prmreportUrl = res[key].reportUrl;
          this.prmreportUrlSecure = res[key].reportUrlSecure;
          this.prmgecmisPostUser = res[key].gecmisPostUser;
          this.prmlanguage = res[key].language;
          this.prmprsBazli = res[key].prsBazli;
          this.prmfirmName = res[key].firmName;
          this.prmfmYemek = res[key].fmYemek;
          this.prmfmUseForm = res[key].fmUseForm;
          this.prmsiUseForm = res[key].siUseForm;
          this.prmsiSaat = res[key].siSaat;
          this.prmgiUseForm = res[key].giUseForm;
          this.prmfmFormOnay = res[key].fmFormOnay;
          this.prmsiFormOnay = res[key].siFormOnay;
          this.prmgiFormOnay = res[key].giFormOnay;
          this.prmonayTuru = res[key].onayTuru;
          this.prmgiDesc = res[key].giAcik;
          this.prmgiYillikIzin = res[key].giYillikIzin;
          this.prmsiDesc = res[key].siAcik;
          this.prmfmDesc = res[key].fmAcik;
          this.prmgiNeden = res[key].giNeden;
          this.prmsiNeden = res[key].siNeden;
          this.prmfmNeden = res[key].fmNeden;
          this.prmfmTip = res[key].fmTip;
          this.prmfmServis = res[key].fmServis;
          this.prmhktUseForm = res[key].hktUseForm;
          this.prmhktFormOnay = res[key].hktFormOnay;
          this.prmhktNeden = res[key].hktNeden;
          this.prmhktDesc = res[key].hktAcik;
          this.prmhktGecmisIslem = res[key].hktGecmisIslem;
          this.prmhktGecmisIslemSure = res[key].hktGecmisIslemSure;

          this.prmpstDesc = res[key].pstAcik;
          this.prmpstGecmisIslem = res[key].pstGecmisIslem;
          this.prmpstGecmisIslemSure = res[key].pstGecmisIslemSure;

          this.prmRet = res[key].ret;
          this.prmgiGecmisIslem = res[key].giGecmisIslemSure;
          this.prmsiGecmisIslem = res[key].siGecmisIslemSure;
          this.prmfmGecmisIslem = res[key].fmGecmisIslemSure;
        });

        // console.log(this.prmreportUrl);

        if (this.userType === "A") {
          this.amrGetApproveInfo(this.user, this.prmonayTuru, null, 0);
        }

        // this.getLanguage(this.prmlanguage);

        // this.getUserLanguage();
        this.getLanguage(JSON.parse(localStorage.getItem("language")!).id);
      },
      (err) => {
        console.log(err);
      },
    );
  }

  ascGetDateCalculation(obj: any): Promise<any> {
    return this.PoolService.getDateCalculation(obj)
      .toPromise()
      .then((data) => {
        return data;
      });
  }

  getDateCalculation(obj: any) {
    this.isLoading = true;
    let config = new MatSnackBarConfig();
    config.panelClass = ["message-position"];
    this.snackBar.open(
      this.languageMap["PROCESS_IN_PROGRESS"].labelName,
      "",
      config,
    );
    this.nextBtn = false;
    obj.leaveReasonId = obj.reasonId;
    this.PoolService.getDateCalculation(obj)
      .toPromise()
      .then(
        (data: any) => {
          this.isLoading = false;
          this.snackBar.dismiss();
          if (data.status == "ERROR") {
            let config = new MatSnackBarConfig();
            config.duration = 3000;
            config.horizontalPosition = "center";
            config.verticalPosition = "top";
            config.panelClass = ["message-position"];
            this.snackBar.open(
              this.languageMap[data.label].labelName,
              "Kapat",
              config,
            );
            return;
          }

          this.secondFormGroup.patchValue({
            enddate: data["endDate"],
            days: data["duration"],
            workstartdate: data["workStartDate"],
          });

          this.nextBtn = true;
          return data;
        },
        (err) => {
          console.log(err);
          this.isLoading = false;
          let config = new MatSnackBarConfig();
          config.duration = 3000;
          config.horizontalPosition = "center";
          config.verticalPosition = "top";
          config.panelClass = ["message-position"];
          this.snackBar.open(err, "Kapat", config);
        },
      );

    return this.nextBtn;
  }

  getTimeCalculation(obj: any) {
    this.ascGetDateCalculation(obj).then((data) => {
      if (data[0].sonuc != "TAMAM") {
        // console.log(data);
        // console.log(data[0].sonuc);
        this.nextBtn = false;
        this.openSnackBar(data[0].sebep, 3);
      }

      // console.log(data[0].sonuc);
      //else { this.nextBtn = true; }
    });
  }

  getUserLanguage() {
    this.ParamService.getLanguage().subscribe((res) => {
      this.usrlanguages = res;
      this.getLanguage(this.usrlanguages[0].id);
    });
  }

  nextBtnChange(enabled: boolean) {
    this.nextBtn = enabled;
  }

  addTab() {
    this.isLoading = true;

    if (this.userType == "A" && this.stepper.selectedIndex == 1)
      this.nextBtn = false;

    if (
      this.userType == "A" &&
      this.flowIndex == 10 &&
      this.stepper.selectedIndex == 1 &&
      this.approve == false
    ) {
      console.log(this.personelInfo[0].id);
      this.PoolService.remoteWorkDays(this.personelInfo[0].id, 0).subscribe(
        (res: any) => {
          console.log(res);
          this.maxMonthlyLimit = res["maxMonthlyRemoteLimit"];
          this.currentUsedBalance = res["currentUsedRemoteDays"];
        },
      );
    }

    let myDate = moment(new Date());
    if (this.userType === "A" && this.flowIndex === 5 && this.nextBtnAlert) {
      let config = new MatSnackBarConfig();
      config.panelClass = ["message-position"];
      config.duration = 3000;
      this.snackBar.open("Saat bilgisi giriniz", "", config);
      this.nextBtn = false;
      this.stepper.previous();
      return;
    }

    this.formOnay = false;
    this.aprDataSource = [];
    let approveData: any = [];
    if (this.flowIndex === 1) {
      if (this.prmgiUseForm || this.prmgiFormOnay)
        this.aprDisplayedColumns = [
          "employeeId",
          "employee",
          "name",
          "startdate",
          "enddate",
          "duration",
          "workstartdate",
          "reasonId",
          "description",
          "dokum",
        ];
      else
        this.aprDisplayedColumns = [
          "employeeId",
          "employee",
          "name",
          "startdate",
          "enddate",
          "duration",
          "workstartdate",
          "reasonId",
          "description",
          "dokum",
        ];
    } else if (this.flowIndex === 2)
      if (this.prmsiUseForm || this.prmsiFormOnay)
        this.aprDisplayedColumns = [
          "employeeId",
          "employee",
          "name",
          "startdate",
          "starttime",
          "endtime",
          "duration",
          "reasonId",
          "description",
          "dokum",
        ];
      else
        this.aprDisplayedColumns = [
          "employeeId",
          "employee",
          "name",
          "startdate",
          "starttime",
          "endtime",
          "duration",
          "reasonId",
          "description",
        ];
    else if (this.flowIndex === 3)
      if (this.prmfmUseForm || this.prmfmFormOnay)
        this.aprDisplayedColumns = [
          "employeeId",
          "employee",
          "name",
          "startdate",
          "duration",
          "reasonId",
          "description",
          "dokum",
        ];
      else
        this.aprDisplayedColumns = [
          "employeeId",
          "employee",
          "name",
          "startdate",
          "duration",
          "reasonId",
          "description",
        ];
    else if (this.flowIndex === 5)
      if (this.prmhktUseForm)
        this.aprDisplayedColumns = ["employee", "name", "dokum"];
      else this.aprDisplayedColumns = ["employee", "name"];
    else if (this.flowIndex === 6)
      this.aprDisplayedColumns = [
        "employeeId",
        "employee",
        "name",
        "startdate",
        "postId",
        "reasonId",
      ];
    else if (this.flowIndex === 8)
      this.aprDisplayedColumns = [
        "employeeId",
        "employee",
        "name",
        "startdate",
        "enddate",
        "reasonId",
        "dokum",
      ];
    else if (this.flowIndex === 9)
      this.aprDisplayedColumns = [
        "employeeId",
        "employee",
        "name",
        "reasonId",
        "startdate",
      ];
    else if (this.flowIndex == 10)
      this.aprDisplayedColumns = [
        "employeeId",
        "employee",
        "name",
        "startdate",
        "enddate",
        "duration",
        "description",
        "dokum",
      ];
    // approveData = [];
    // console.log(this.userType);
    let data: any = {};
    if (this.userType === "P") {
      if (this.flowIndex === 5) {
        this.addTimeIO();
      }

      let obj: any = {};
      obj = {
        type: this.flowIndex,
        sirket: "1",
        sicilNo: this.user,
        neden: this.secondFormGroup.value.reasonItem,
        basTarih: formatDate(
          this.secondFormGroup.value.startdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        bitTarih:
          this.dayDateChange === "date"
            ? null
            : formatDate(
                this.secondFormGroup.value.enddate,
                "yyyy-MM-dd",
                "en-US",
              ),
        gun:
          this.dayDateChange === "picker"
            ? null
            : this.secondFormGroup.value.days, //this.secondFormGroup.value.days,

        isBasiTarih: formatDate(
          this.secondFormGroup.value.workstartdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        sebep: "",
        reasonId: this.secondFormGroup.value.reason,
        aciklama: "",
        idNo: 0,
        user: this.user,
      };
    } else {
      if (this.stepper.selectedIndex == 2) {
        if (this.flowIndex == 10) {
          const { startOfWeek, endOfWeek } = this.getWeekRange(
            this.bcsRemoteWorkDays[0].selectedDate,
          );

          const formattedDates = this.bcsRemoteWorkDays
            .map((item) => {
              const dateStr = new Date(item.selectedDate).toLocaleDateString(
                "tr-TR",
              );
              const currentLang = "tr-TR";
              const dayName = new Date(item.selectedDate).toLocaleDateString(
                currentLang,
                { weekday: "long" },
              );
              const localizedDayLabel =
                this.languageMap[dayName].labelName || dayName;
              return `${dateStr} - ${localizedDayLabel}`;
            })
            .join("\n");

          this.secondFormGroup.patchValue({
            startdate: startOfWeek,
            enddate: endOfWeek,
            days: this.bcsRemoteWorkDays[0]["duration"],
            reasonItem: 1,
            reason: formattedDates,
          });
        }

        let data = {
          approveTypeId: this.flowIndex,
          companyId: Number(sessionStorage.getItem("companyid")),
          employeeId: Number(this.personelInfo[0].id),
          employee: this.personelInfo[0].employee,
          name: this.personelInfo[0].name,
          startdate: formatDate(
            this.secondFormGroup.value.startdate,
            "yyyy-MM-dd",
            "en-US",
          ),
          starttime: this.secondFormGroup.value.starttime,
          enddate: formatDate(
            this.secondFormGroup.value.enddate,
            "yyyy-MM-dd",
            "en-US",
          ), //formatDate(data1[0].enddate, "yyyy-MM-dd", "en-US"),
          endtime: this.secondFormGroup.value.endtime,
          duration:
            this.flowIndex == 1 || this.flowIndex == 10
              ? this.secondFormGroup.value.days
              : this.secondFormGroup.value.times,
          workstartdate: formatDate(
            this.secondFormGroup.value.workstartdate,
            "yyyy-MM-ddT00:00:00",
            "en-US",
          ),
          reasonId: this.secondFormGroup.value.reasonItem,
          postId: this.secondFormGroup.value.postaItem,
          description: this.secondFormGroup.value.reason,
          description2: this.secondFormGroup.value.reason2,
        };
        approveData.push(data);
        // });
      }

      if (this.approve) {
        if (this.stepper.selectedIndex == 1)
          this.amrDataSource.data.forEach(async (element: any) => {
            if (element.approved || element.rejected) {
              element.approveTypeId = this.flowIndex;
              element.rejectDscr = element.retacik;
              let req: any = {};
              req.bcsApprove = element;
              req.bcsRemoteWorkDays = this.bcsRemoteWorkDays;
              this.PoolService.putPoolApprove(req).subscribe(
                (res: any) => {
                  this.isLoading = false;
                  if (res.status == "ERROR") {
                    this.isLoading = false;
                    this.isSuccess = false;
                    this.statusMessage =
                      this.languageMap[res.message].labelName;
                    return;
                  }
                  this.isSuccess = true;
                  if (res.nextApproverDegree == null)
                    this.statusMessage = res.nextApproverName;
                  else
                    this.statusMessage =
                      res.nextApproverName +
                      " " +
                      this.languageMap["WAITING_FOR_CHIEF_APPROVAL"].labelName;

                  this.stepper.next();
                  this.clearTabs();
                  // }
                },
                (err) => {
                  this.isSuccess = false;
                  this.statusMessage = this.languageMap[err].labelName;
                  this.isLoading = false;
                  this.snackBar.dismiss();
                },
              );
            }
          });
      }

      if (
        (this.flowIndex === 1 ||
          this.flowIndex === 2 ||
          this.flowIndex === 3 ||
          this.flowIndex === 10) &&
        this.stepper.selectedIndex === 2
      ) {
        this.snackBar.dismiss();
        this.nextBtn = true;
      }
    }

    this.aprDataSource = new MatTableDataSource<DailyApproverElement>(
      approveData,
    );
    this.aprDataSource.paginator = this.aprPaginator;
    this.aprDataSource.sort = this.aprSort;
  }

  getTimeInterval(startTime: any, endTime: any) {
    var start = moment(startTime, "HH:mm");
    var end = moment(endTime, "HH:mm");
    var minutes = end.diff(start, "minutes");
    var interval = moment().hour(0).minute(minutes);
    return interval.format("HH:mm");
  }

  addTimeIO() {
    let obj: any = {};

    if (this.userType === "P") {
      if (this.secondFormGroup.value.iostarttime === "00:00") return false;

      obj = {
        type: this.flowIndex,
        company: "1",
        employee: this.user, //((this.userType === 'A') ? this.personelInfo[0].username : this.user),
        reason: this.secondFormGroup.value.reasonItem, // 15,
        startdate: formatDate(
          this.secondFormGroup.value.startdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        enddate: formatDate(
          this.secondFormGroup.value.enddate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        starttime: this.secondFormGroup.value.starttime,
        endtime: this.secondFormGroup.value.endtime,
        duration: this.secondFormGroup.value.iostarttime,
        iobasTarih: formatDate(
          this.secondFormGroup.value.iostartdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        iobasSure: this.secondFormGroup.value.iostarttime,
        inoutput: this.secondFormGroup.value.inoutput,
        description: "", //this.secondFormGroup.value.reason2,
        description2: "", //this.secondFormGroup.value.reason,
        id: 0,
        user: this.user,
      };
    } else {
      obj = {
        type: this.flowIndex,
        company: "1",
        employee:
          this.userType === "A" ? this.personelInfo[0].username : this.user,
        reason: this.secondFormGroup.value.reasonItem, // 15,
        startdate: formatDate(
          this.secondFormGroup.value.startdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        enddate: formatDate(
          this.secondFormGroup.value.enddate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        starttime: this.secondFormGroup.value.starttime,
        endtime: this.secondFormGroup.value.endtime,
        duration: this.secondFormGroup.value.iostarttime,
        iobasTarih: formatDate(
          this.secondFormGroup.value.iostartdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        iobasSure: this.secondFormGroup.value.iostarttime,
        inoutput: this.secondFormGroup.value.inoutput,
        description: "", //this.secondFormGroup.value.reason2,
        description2: "", //this.secondFormGroup.value.reason,
        id: 0,
        user: this.user,
      };
    }

    this.getTimeCalculation(obj);
  }

  addTime(source: any) {
    let start = moment(this.secondFormGroup.value.startdate);
    let end = moment(this.secondFormGroup.value.enddate);

    let myDate = moment(new Date());
    let sure =
      this.flowIndex === 1
        ? this.prmgiGecmisIslem
        : this.flowIndex === 2
          ? this.prmsiGecmisIslem
          : this.flowIndex === 3
            ? this.prmfmGecmisIslem
            : this.flowIndex === 6
              ? this.prmpstGecmisIslemSure
              : 0;
    if (myDate.diff(start, "days") > sure) {
      this.openSnackBar(sure + " gün geriye giriş yapılamaz.", 3);
      this.secondFormGroup.patchValue({ days: null });
      this.nextBtn = false;
      return;
    } else this.nextBtn = true;

    if (source === "diff" && this.prmfmTip === 1) {
      if (this.prmsiSaat) {
        let sure = this.secondFormGroup.value.times.replace(":", "");
        if (Number(sure) < 30) {
          this.openSnackBar("30dk küçük izin girilemez.", 1);
          this.nextBtn = false;
          return;
        } else this.nextBtn = true;
      }
      let diff = moment(this.secondFormGroup.value.times, "HH:mm").diff(
        moment("00:00", "HH:mm"),
        "minutes",
      );
      this.secondFormGroup.patchValue({
        endtime: moment(this.secondFormGroup.value.starttime, "HH:mm")
          .add(diff, "minutes")
          .format("HH:mm"),
      });
    } else if (source === "diff" && this.prmfmTip === 0) {
      if (this.prmsiSaat) {
        let sure = this.secondFormGroup.value.times.replace(":", "");
        if (Number(sure) < 30) {
          this.openSnackBar("30dk küçük izin girilemez.", 1);
          this.nextBtn = false;
          return;
        } else this.nextBtn = true;
        this.secondFormGroup.patchValue({
          times: moment(this.secondFormGroup.value.times, "HH:mm").format(
            "HH:mm",
          ),
        });
      }
    } else if (source === "time") {
      let start = moment(this.secondFormGroup.value.starttime, "HH:mm");
      let end = moment(this.secondFormGroup.value.endtime, "HH:mm");
      let sure = this.getTimeInterval(start, end).replace(":", "");

      if (this.prmsiSaat) {
        if (Number(sure) < 30) {
          this.openSnackBar("30dk küçük izin girilemez.", 1);
          this.nextBtn = false;
          return;
        } else this.nextBtn = true;
      }

      this.secondFormGroup.patchValue({
        times: this.getTimeInterval(start, end),
      });
    }

    // console.log(this.personelInfo);
    if (this.userType === "A")
      for (var i = 0, len = this.personelInfo.length; i < len; i++) {
        let obj: any = {};
        obj = {
          type: this.flowIndex,
          company: "1",
          employeee: this.personelInfo[i].employee,
          reason: this.secondFormGroup.value.reasonItem, // 15,
          startdate: formatDate(
            this.secondFormGroup.value.startdate,
            "yyyy-MM-ddT00:00:00",
            "en-US",
          ),
          enddate: formatDate(
            this.secondFormGroup.value.enddate,
            "yyyy-MM-ddT00:00:00",
            "en-US",
          ),
          starttime: this.secondFormGroup.value.starttime,
          endtime: this.secondFormGroup.value.endtime,
          duration: source === "picker" ? 0 : this.secondFormGroup.value.times,
          iobasTarih: formatDate(
            this.secondFormGroup.value.iostartdate,
            "yyyy-MM-ddT00:00:00",
            "en-US",
          ),
          iobasSure: this.secondFormGroup.value.iostarttime,
          inoutput: this.secondFormGroup.value.inoutput,
          description: "", //this.secondFormGroup.value.reason2,
          description2: "", //this.secondFormGroup.value.reason,
          id: 0,
          user: this.user,
        };

        this.getTimeCalculation(obj);
      }
    else {
      let obj: any = {};
      obj = {
        type: this.flowIndex,
        company: "1",
        employee: this.user,
        reason: this.secondFormGroup.value.reasonItem, // 15,
        startdate: formatDate(
          this.secondFormGroup.value.startdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        enddate: formatDate(
          this.secondFormGroup.value.enddate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        starttime: this.secondFormGroup.value.starttime,
        endtime: this.secondFormGroup.value.endtime,
        duration: source === "picker" ? 0 : this.secondFormGroup.value.times,
        iobasTarih: formatDate(
          this.secondFormGroup.value.iostartdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        iobasSure: this.secondFormGroup.value.iostarttime,
        inoutput: this.secondFormGroup.value.inoutput,
        description: "", //this.secondFormGroup.value.reason2,
        description2: "", //this.secondFormGroup.value.reason,
        id: 0,
        user: this.user,
      };

      this.getTimeCalculation(obj);
    }
  }

  reasonItemChange(e: any) {
    if (this.flowIndex === 5) {
      this.secondFormGroup.patchValue({ iostarttime: null });
    }
    if (this.flowIndex === 1) {
      this.secondFormGroup.patchValue({ enddate: null, days: null });
    }
    if (this.flowIndex === 9) {
      this.secondFormGroup.patchValue({ amirkodu: null, amiradi: null });
    }
    this.selectedReason = e.value;
  }

  postaItemChange() {
    if (this.flowIndex === 6)
      this.secondFormGroup.patchValue({ startdate: null });
  }

  createColumn() {
    this.shiftDates = [];
    let start = moment(this.thirdFormGroup.value.shiftDate1);
    let end = moment(this.thirdFormGroup.value.shiftDate2);
    let diff = end.diff(start, "days");
    for (var i = 0, len = diff; i <= len; i++) {
      let myDate = start;
      this.shiftDates.push(
        formatDate(myDate.toString(), "dd-MM-yyyy", "en-US"),
      );
      myDate.add(1, "days");
    }
  }

  addDay(source: any) {
    if (this.flowIndex === 2 || this.flowIndex === 3) {
      this.secondFormGroup.patchValue({
        enddate: this.secondFormGroup.value.startdate,
        starttime: null,
        endtime: null,
      });
      this.nextBtn = false;
      return;
    }

    this.dayDateChange = source;
    // if (this.flowIndex !== 8 && this.secondFormGroup.value.reasonItem === null && this.secondFormGroup.value.postaItem === null) {
    //   this.openSnackBar(this.flowIndex === 6 ? 'Hafta Tatili girilmelidir.' : 'Neden girilmelidir.', 3);
    //   this.secondFormGroup.patchValue({ startdate: null, enddate: null });
    //   this.nextBtn = false;
    //   return;
    // }

    let start = moment(this.secondFormGroup.value.startdate);
    let end = moment(this.secondFormGroup.value.enddate);

    if (end.diff(start, "days") < 0) {
      this.openSnackBar("Bitiş Tarihi Baş. Tarihten küçük olamaz.", 3);
      this.secondFormGroup.patchValue({ enddate: null });
      this.nextBtn = false;
      return;
    }

    let myDate = moment(new Date());
    let sure =
      this.flowIndex === 1
        ? this.prmgiGecmisIslem
        : this.flowIndex === 2
          ? this.prmsiGecmisIslem
          : this.flowIndex === 3
            ? this.prmfmGecmisIslem
            : this.flowIndex === 6
              ? this.prmpstGecmisIslemSure
              : 0;
    if (myDate.diff(start, "days") > sure) {
      this.openSnackBar(sure + " gün geriye giriş yapılamaz.", 3);
      this.secondFormGroup.patchValue({ days: null });
      this.nextBtn = false;
      return;
    } else this.nextBtn = true;

    if (this.flowIndex !== 6 && this.flowIndex !== 8) {
      if (this.flowIndex == 1 || this.flowIndex == 2 || this.flowIndex == 3) {
        if (source == "picker" && this.secondFormGroup.value.enddate == null)
          this.secondFormGroup.patchValue({
            enddate: this.secondFormGroup.value.startdate,
            starttime: "00:00",
            endtime: "00:00",
          });
        if (this.flowIndex == 3) return;
      }

      if (this.secondFormGroup.value.startdate === null) return;
      if (
        this.secondFormGroup.value.enddate === null &&
        this.secondFormGroup.value.days === 0
      )
        return;
    }

    if (this.flowIndex !== 8) {
      let obj: any = {};
      obj = {
        type: this.flowIndex === 2 ? 1 : this.flowIndex,
        companyId: sessionStorage.getItem("companyid"),
        employee:
          this.userType === "A" ? this.personelInfo[0].employee : this.user,
        reasonId:
          this.flowIndex === 6 ? 0 : this.secondFormGroup.value.reasonItem, // 15,
        postId:
          this.flowIndex === 6
            ? this.secondFormGroup.value.postaItem.split("-")[0]
            : "0", // 15,
        startdate: formatDate(
          this.secondFormGroup.value.startdate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        duration: source === "picker" ? null : this.secondFormGroup.value.days,
        // bitTarih: ((this.dayDateChange === "date") ? null : (formatDate(this.secondFormGroup.value.enddate, "yyyy-MM-dd", "en-US"))),
        enddate: formatDate(
          this.secondFormGroup.value.enddate,
          "yyyy-MM-ddT00:00:00",
          "en-US",
        ),
        workstartdate: "1900-01-01T00:00:00.000Z",
        description: "", //this.secondFormGroup.value.reason2,
        description2: "", //this.secondFormGroup.value.reason,
        employmentId: this.personelInfo[0].id,
        user: this.user,
      };

      this.getDateCalculation(obj);
    }
  }

  getAuth(user: any, type: any) {
    this.AuthService.getPoolAuth().subscribe(
      (res: any) => {
        this.outofoffice[1].auth = res["gunluk"];
        this.outofoffice[2].auth = res["saatlik"];
        this.outofoffice[3].auth = res["mesai"];
        // this.outofoffice[4].auth = res["vardiya"];
        // this.outofoffice[5].auth = res["hareket"];
        this.outofoffice[6].auth = res["posta"];

        this.outofoffice[8].auth = res["rotasyon"];
        this.outofoffice[9].auth = res["guncelleme"];
        this.outofoffice[10].auth = res["evden"];
        this.prmamir1 = res["amir1"];

        // for (var i = 0, len = this.outofoffice.length; i < len; i++) {
        //   if (this.outofoffice[i].auth === true) {
        //     this.outofofficeCount++;
        //   }
        // }

        // else if (this.outofoffice[2].auth)
        // this.printRules="[0,1,2,3]";
      },
      (err) => {
        console.log(err);
      },
    );
  }

  isAllSelected() {
    // const numSelected = this.usrSelection.selected.length;
    // const numRows = this.usrDataSource.data.length;
    // return numSelected === numRows;
    return false;
  }

  isAmrAllSelected() {
    const numSelected = this.amrSelection.selected.length;
    const numRows = this.amrDataSource.data.length;
    return numSelected === numRows;
  }

  remove(id: string): void {
    this.personelInfo = this.personelInfo.filter((item: any) => item.id !== id);
  }

  checkboxLabel(row?: UserElement): string {
    if (!row) {
      return `${this.isAllSelected() ? "select" : "deselect"} all`;
    }
    return `${
      this.usrSelection.isSelected(row) ? "deselect" : "select"
    } row ${row.id + 1}`;
  }

  tabNextControl() {
    if (this.userType === "P") this.nextBtn = true;

    if (
      (this.stepper.selectedIndex === 0 || this.stepper.selectedIndex === 1) &&
      this.flowIndex !== 5
    ) {
      this.nextBtn = this.personelInfo.length === 0 ? false : true;
    }
  }

  usrMasterToggle(row: any) {
    this.usrSelection.toggle(row);
    if (row !== undefined) {
      let obj = {
        id: row.id,
        employee: row.employee,
        name: row.name,
        iostartdate: row.iostartdate,
        inoutput: row.inoutput,
        ioreasonItem: row.ioreasonItem,
        iodesc: row.iodesc,
        iostarttime: row.iostarttime,
        departmentId: row.departmentId,
        useYemek: row.useYemek,
        useServiceArrival: row.useServiceArrival,
        useServiceGoing: row.useServiceGoing,
        serviceArrival: row.serviceArrival,
        serviceGoing: row.serviceGoing,
        yillikKalan: row.yillikKalan,
      };

      if (this.personelInfo.length === 0) this.nextBtn = false;
      else if (this.flowIndex === 5) {
        if (this.usrSelection.isSelected(row)) {
          this.nextBtn = false;
        }
      }

      if (!this.usrSelection.isSelected(row)) {
        row.serviceArrival = "";
        row.serviceGoing = "";
        row.useServiceGoing = "";
        row.useServiceArrival = "";
        row.useYemek = "";
        row.inoutput = "";
        row.ioreasonItem = "";
        row.iodesc = "";
        row.iostartdate = "";
        row.iostarttime = "";
        row.yillikKalan = "";
        this.remove(obj.id);
      } else {
        this.personelInfo.push(obj);
      }
    }

    // console.log(this.personelInfo);
    this.tabNextControl();
  }

  openSnackBar(message: string, seconds: number) {
    let config = new MatSnackBarConfig();
    // config.panelClass = ['message-position'];
    config.duration = seconds * 1000;
    config.verticalPosition = "top";
    this.snackBar.open(message, "", config);
  }

  getFormTemplate(obj: any) {
    // console.log(obj);
    this.PoolService.getTemplate(obj).subscribe(
      (res) => {
        let response: any = [];
        response = res;
        const dialogRef = this.dialog.open(FormLayout, {
          height: "1442px",
          width: "1095px",
          data: {
            // html: '<div [innerHTML]="'+response.template+' | SafeHtml"></div>'
            html: response.template,
          },
        });
        // console.log('<div [innerHTML]="'+response.template+'"></div>');
        this.formOnay = true;
      },
      (err) => {
        console.log(err);
      },
    );

    // this.PoolService.getTemplate(obj)
    //   .subscribe((res) => {
    //     //  this.formTemplate=res.template;
    //   }, err => {
    //     console.log(err);
    //   });
  }

  clearTabs() {
    this.secondFormGroup.patchValue({
      starttime: null,
      useYemek: null,
      enddate: null,
      endtime: null,
      useServiceArrival: null,
      useServiceGoing: null,
      arrivalservice: null,
      goingservice: null,
      days: null,
      times: null,
      reasonItem: null,
      reason: null,
      reason2: null,
    });

    this.thirdFormGroup.patchValue({ chkApprove: null, onayTuru: "Inbox" });
  }

  remoteSelectedDates(selected: any) {
    console.log(selected);
    this.bcsRemoteWorkDays = [];
    selected.selectedDate.forEach((element: any) => {
      this.bcsRemoteWorkDays.push({
        companyId: Number(sessionStorage.getItem("companyid")),
        employeeId: selected.employeeId,
        selectedDate: element,
        duration: selected.duration,
      });
    });
  }

  getWeekRange(selectedDate: Date) {
    const current = new Date(selectedDate);

    // 1. Haftanın kaçıncı günündeyiz bulalım (0: Pazar, 1: Pazartesi, ..., 6: Cumartesi)
    const dayOfWeek = current.getDay();

    // 2. Pazartesiye dönmek için kaç gün geri gitmemiz gerektiğini hesaplayalım.
    // JavaScript'te haftanın ilk günü Pazar (0) kabul edildiği için Pazar gününü özel olarak yönetiyoruz.
    const distanceToMonday = dayOfWeek === 0 ? -6 : 1 - dayOfWeek;

    // 3. Hafta Başı (Pazartesi) Hesaplama
    const monday = new Date(current);
    monday.setDate(current.getDate() + distanceToMonday);
    monday.setHours(0, 0, 0, 0); // Saatleri sıfırlayarak tam gün çizgisine çekiyoruz

    // 4. Hafta Sonu (Pazar) Hesaplama (Pazartesiye 6 gün ekliyoruz)
    const sunday = new Date(monday);
    sunday.setDate(monday.getDate() + 6);
    sunday.setHours(23, 59, 59, 999); // Hafta sonunun tam bitiş anı

    return {
      startOfWeek: monday,
      endOfWeek: sunday,
    };
  }

  sendToApprove() {
    // let config = new MatSnackBarConfig();
    // config.panelClass = ['message-position'];
    // this.snackBar.open("İşlem yapılıyor. Lütfen Bekleyiniz...", "", config);
    this.isLoading = true;
    let req: any = {};
    this.aprDataSource.data[0].chief = this.userType === "A" ? true : false;
    this.aprDataSource.data[0].chiefCode = this.user;
    this.aprDataSource.data[0].approved = true;
    this.aprDataSource.data[0].rejected = false;
    this.aprDataSource.data[0].chiefId = Number(
      sessionStorage.getItem("userid"),
    );

    let obj = this.aprDataSource.data[0];
    if (this.flowIndex == 1) {
      obj.starttime = "00:00:00";
      obj.endtime = "00:00:00";
      obj.totaltime = "00:00:00";
    } else if (this.flowIndex == 2) {
      obj.starttime =
        obj.starttime.split(":").length === 2
          ? `${obj.starttime}:00`
          : obj.starttime;
      obj.endtime =
        obj.endtime.split(":").length === 2 ? `${obj.endtime}:00` : obj.endtime;
      const orginalDuration = obj.duration;
      const parts = obj.duration.split(":");
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      const totalHours = hours + minutes / 60;
      const durationInDays: number = totalHours / 8;
      obj.duration = durationInDays;
      obj.totaltime = this.getTimeInterval(obj.starttime, obj.endtime);
      obj.totaltime =
        obj.totaltime.split(":").length === 2
          ? `${obj.totaltime}:00`
          : obj.totaltime;
    } else if (this.flowIndex == 3) {
      obj.starttime = "00:00:00";
      obj.endtime = "00:00:00";
      obj.totaltime =
        obj.duration.split(":").length === 2
          ? `${obj.duration}:00`
          : obj.duration;
      const parts = obj.duration.split(":");
      const hours = parseInt(parts[0], 10);
      const minutes = parseInt(parts[1], 10);
      const totalHours = hours + minutes / 60;
      const durationInDays: number = totalHours / 8;
      obj.duration = durationInDays;
    } else if (this.flowIndex == 10) {
      const { startOfWeek, endOfWeek } = this.getWeekRange(
        this.bcsRemoteWorkDays[0].selectedDate,
      );

      // bcsRemoteWorkDays.bcsRemoteWorkDays = this.bcsRemoteWorkDays;
      obj.startdate = startOfWeek;
      obj.enddate = endOfWeek;
      obj.duration = this.bcsRemoteWorkDays[0]["duration"];
      obj.reasonId = 1;
    }

    req.bcsApprove = obj;
    req.bcsRemoteWorkDays = this.bcsRemoteWorkDays;
    this.PoolService.postPoolApprove(req).subscribe(
      (res: any) => {
        this.isLoading = false;
        if (res.status == "ERROR") {
          this.isLoading = false;
          this.isSuccess = false;
          this.statusMessage = this.languageMap[res.message].labelName;
          return;
        }
        this.isSuccess = true;
        if (res.isFinalApproval) this.statusMessage = res.nextApproverName;
        else
          this.statusMessage =
            res.nextApproverName +
            " " +
            this.languageMap["WAITING_FOR_CHIEF_APPROVAL"].labelName;

        this.stepper.next();
        this.clearTabs();

        // }
      },
      (err) => {
        this.isSuccess = false;
        this.statusMessage = err;
        // this.statusMessage = this.languageMap[err].labelName;        this.statusMessage = this.languageMap[err].labelName;
        this.snackBar.dismiss();
        // console.log(err);
        // Backend'den gelen özel hata mesajını yakalamak (Örn: "Bu tarihler arasında zaten aktif bir izin talebi mevcut.")
        // Eğer err.error.message varsa onu, yoksa genel err.message alanını gösteriyoruz
        const errorMessage =
          err.error && err.error.message ? err.error.message : err.message;

        let config = new MatSnackBarConfig();
        config.duration = 4000; // Kullanıcının okuyabilmesi için süreyi biraz uzattık
        config.horizontalPosition = "center"; // Yatayda tam ortala
        config.verticalPosition = "top"; // Mobil uyum için dikeyde üstte göstermek en doğrusudur (İsterseniz 'bottom' yapabilirsiniz)
        config.panelClass = ["custom-responsive-snackbar"]; // Özel responsive stil sınıfımız

        this.snackBar.open(this.languageMap[err].labelName, "Kapat", config);
        this.isLoading = false;
      },
    );
  }

  amrApprove() {
    this.isLoading = true;
    let config = new MatSnackBarConfig();
    config.panelClass = ["message-position"];
    this.snackBar.open(
      this.languageMap["PROCESS_IN_PROGRESS"].labelName,
      "",
      config,
    );
    const obj = this.amrDataSource.data.filter(
      (item: any) => item.approved == true || item.rejected == true,
    );
    this.PoolService.amrApprove(this.flowIndex, obj).subscribe(
      (res) => {
        let response = res;

        // if (response.isSuccess===false)
        // {
        //   let config = new MatSnackBarConfig();
        //   config.panelClass = ['message-position'];
        //   config.duration=3000;
        //   this.snackBar.open(response.returnMessage, "", config);

        // }
        // this.openSnackBar(response["ReturnMessage"].toString(), 3);
        if (this.userType === "A") {
          this.amrGetApproveInfo(this.user, this.prmonayTuru, null, 0);
        }

        this.snackBar.dismiss();
        this.stepper.next();
        this.isSuccess = true;
        this.statusMessage = this.languageMap["PROCESS_SUCCESS"].labelName;
        this.isLoading = false;
      },
      (err) => {
        console.log(err);
        this.isSuccess = false;
        this.statusMessage = this.languageMap[err].labelName;
        this.isLoading = false;
        const errorMessage =
          err.error && err.error.message ? err.error.message : err.message;
        let config = new MatSnackBarConfig();
        config.duration = 4000;
        config.horizontalPosition = "center"; // Yatayda tam ortala
        config.verticalPosition = "top"; // Mobil uyum için dikeyde üstte göstermek en doğrusudur (İsterseniz 'bottom' yapabilirsiniz)
        config.panelClass = ["custom-responsive-snackbar"]; // Özel responsive stil sınıfımız
        this.snackBar.open(errorMessage, "Kapat", config);
      },
    );
  }

  openDialog(flowIndex: number): void {
    if (flowIndex == 1) this.printRules = "[0,1,4,5,6,7,8]";
    else if (
      flowIndex == 2 ||
      flowIndex == 4 ||
      flowIndex == 5 ||
      flowIndex == 7
    )
      this.printRules = "[0,1,4,5,6,7,8,9]";
    else if (flowIndex == 3) this.printRules = "[0,1,4,6,7,8,9,10]";
    else if (flowIndex == 6)
      // Posta
      this.printRules = "[0,1,4,5,6,7,8,9]";
    else this.printRules = "[]";

    this.firstFormGroup = this._formBuilder.group({
      firstCtrl: [],
    });
    this.secondFormGroup = this._formBuilder.group({
      startdate: [],
      starttime: [],
      yillikKalan: [],
      yillikFazlaMesai: [],
      useYemek: [],
      enddate: [],
      endtime: [],
      workstartdate: [],
      inoutput: [],
      iostartdate: [],
      iostarttime: [],
      useServiceArrival: [],
      useServiceGoing: [],
      arrivalservice: [],
      goingservice: [],
      days: [],
      times: [],
      reasonItem: [],
      amirkodu: [],
      amiradi: [],
      postaItem: [],
      reason: [],
      reason2: [],
    });

    // if (this.outofoffice[4].value && this.userType === 'P') return;

    this.thirdFormGroup = this._formBuilder.group({
      chkApprove: ["", Validators.required],
      shiftDate1: [],
      shiftDate2: [],
      onayTuru: ["Inbox"],
    });

    if (this.userType === "A") this.nextBtn = false;
    else this.nextBtn = true;

    // this.PoolService.getPoolUsers(userName, this.userType).subscribe(
    //   res => {
    //     Object.keys(res).forEach(key => {
    //       this.usrData[key] = res[key];
    //       this.approver = res[key].approver;
    //     });
    //   },
    //   err => {
    //     console.log(err);
    // }
    // );
    this.secondFormGroup.patchValue({
      starttime: null,
      useYemek: null,
      enddate: null,
      yillikKalan: null,
      endtime: null,
      useServiceArrival: null,
      useServiceGoing: null,
      arrivalservice: null,
      goingservice: null,
      days: null,
      times: null,
      reasonItem: null,
      reason: null,
      reason2: null,
    });
    this.thirdFormGroup.patchValue({
      chkApprove: null,
      onayTuru: "Inbox",
    });
    this.flowIndex = flowIndex;
    this.getReason(this.user, this.flowIndex);
    // this.getPosta();

    if (flowIndex === 1) {
      this.secondFormGroup.patchValue({ days: 0 });
      // if (this.secondFormGroup.value.startdate != null && this.secondFormGroup.value.enddate != null)
      //   this.addDay("picker");

      // this.addDay("picker");
    }
    // || (this.prmamir1 && !this.prmprsBazli)
    if (this.userType === "P") {
      this.openFlow(flowIndex, false);
      return;
    }

    // if (flowIndex != 4) {
    const dialogRef = this.dialog.open(DialogApprove, {
      width: "380px",
      height: "auto",
      data: {
        insert: false,
        approve: false,
        auth:
          this.userType == "A" && flowIndex !== 8 && flowIndex !== 9
            ? "A"
            : "P",
        color: this.outofoffice[flowIndex].color,
        entryLabel: this.languageMap["btnEntry"].labelName,
        approveLabel: this.languageMap["btnApprove"].labelName,
        selectLabel: this.languageMap["SELECT_ACTION"].labelName,
      },
      panelClass: "my-dialog-container-class",
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result.insert) {
        this.approve = false;
        this.openFlow(flowIndex, false);
      } else {
        this.approve = true;
        this.openFlow(flowIndex, true);
        this.amrGetApproveInfo(this.user, this.prmonayTuru, flowIndex, 0);
      }
    });
    // }
  }

  amrGetApproveInfo(
    user: any,
    prmonayTuru?: any,
    type?: any,
    filterType?: any,
  ) {
    this.amrDataSource = [];
    this.pageIndex = 100;
    this.PoolService.getPoolApproves(prmonayTuru, type, filterType).subscribe(
      (res: any) => {
        this.usrData = [];
        Object.keys(res).forEach((key: any) => {
          this.usrData[key] = res[key];
        });

        if (type == null) {
          let amrApproveData = [];
          let data: any = {};
          this.outofoffice[1].matBadge = 0;
          this.outofoffice[2].matBadge = 0;
          this.outofoffice[3].matBadge = 0;
          this.outofoffice[4].matBadge = 0;
          this.outofoffice[5].matBadge = 0;
          this.outofoffice[6].matBadge = 0;
          this.outofoffice[8].matBadge = 0;
          this.outofoffice[9].matBadge = 0;
          this.outofoffice[10].matBadge = 0;

          for (var i = 0, len = this.usrData.length; i < len; i++) {
            if (this.usrData[i]["izinTip"] === 1)
              this.outofoffice[1].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 2)
              this.outofoffice[2].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 3)
              this.outofoffice[3].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 4)
              this.outofoffice[4].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 5)
              this.outofoffice[5].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 6)
              this.outofoffice[6].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 9)
              this.outofoffice[9].matBadge = this.usrData[i]["adet"];
            if (this.usrData[i]["izinTip"] === 10)
              this.outofoffice[10].matBadge = this.usrData[i]["adet"];
          }
        } else {
          let amrApproveData = [];
          let data: any = {};
          for (var i = 0, len = this.usrData.length; i < len; i++) {
            data = {
              id: this.usrData[i]["id"],
              approveTypeId: this.usrData[i]["approveTypeId"],
              approved: false,
              rejected: false,
              attendanceId: this.usrData[i]["attendanceId"],
              companyId: this.usrData[i]["companyId"],
              company: this.usrData[i]["company"],
              employeeId: this.usrData[i]["employeeId"],
              employee: this.usrData[i]["employee"].toString(),
              chiefId: this.usrData[i]["chiefId"],
              name: this.usrData[i]["name"],
              yillikKalan: this.usrData[i]["yillikKalan"],
              yillikFazlaMesai: this.usrData[i]["yillikFazlaMesai"],
              startdate: formatDate(
                this.usrData[i]["startdate"],
                "yyyy-MM-dd",
                "en-US",
              ),
              date: formatDate(this.usrData[i]["date"], "yyyy-MM-dd", "en-US"),
              starttime: this.usrData[i]["starttime"],
              duration: Number(this.usrData[i]["duration"]),
              totaltime: this.usrData[i]["totaltime"],
              amir: this.user,
              enddate: formatDate(
                this.usrData[i]["enddate"],
                "yyyy-MM-dd",
                "en-US",
              ),
              endtime: this.usrData[i]["endtime"],
              workstartdate: formatDate(
                this.usrData[i]["workstartdate"],
                "yyyy-MM-dd",
                "en-US",
              ),
              reasonId: this.usrData[i]["reasonId"],
              reason: this.usrData[i]["reason"],
              description: this.usrData[i]["description"],
              description2: this.usrData[i]["description2"],
              rejectDscr: this.usrData[i]["rejectDscr"],
              postId: this.usrData[i]["postId"],
              departId: this.usrData[i]["departId"],
              bcsRemoteWorkDays: this.usrData[i]["bcsRemoteWorkDays"],
            };

            if (this.usrData.length > 0) {
              this.prmAuth = !this.usrData[0]["auth"];
            }

            amrApproveData.push(data);
          }
          if (this.isMobile)
            this.amrDisplayedColumns = [
              "action",
              "attendanceId",
              "approveTypeId",
              "id",
              "employee",
              "name",
              "yillikKalan",
              "yillikFazlaMesai",
              "startdate",
              "starttime",
              "postId",
              "date",
              "enddate",
              "endtime",
              "workstartdate",
              "duration",
              "totaltime",
              "reason",
              "rejectDscr",
              "departId",
              "dokum",
            ];
          else
            this.amrDisplayedColumns = [
              "approved",
              "rejected",
              "attendanceId",
              "approveTypeId",
              "id",
              "employee",
              "name",
              "yillikKalan",
              "yillikFazlaMesai",
              "startdate",
              "starttime",
              "postId",
              "date",
              "enddate",
              "endtime",
              "workstartdate",
              "duration",
              "totaltime",
              "reason",
              "description",
              "rejectDscr",
              "departId",
              "dokum",
            ];

          this.amrDataSource = new MatTableDataSource<any>(amrApproveData);
          this.amrSelection = new SelectionModel<any>(true, []);
          this.amrDataSource.paginator = this.amrPaginator;
          this.amrDataSource.sort = this.amrSort;
        }
      },
      (err) => {
        console.log(err);
      },
    );
  }

  gotoPreviousPage() {
    if (this.stepper.selectedIndex === 1) {
      if (this.flowIndex === 1)
        this.secondFormGroup.patchValue({ enddate: null, days: null });
      if (this.flowIndex === 2)
        this.secondFormGroup.patchValue({
          starttime: null,
          endtime: null,
          times: null,
        });
      if (this.flowIndex === 3)
        this.secondFormGroup.patchValue({ times: null });
    }
    this.stepper.previous();
  }

  closeDialog() {
    this.stepper.reset();
    this.snackBar.dismiss();
    if (this.userType === "A") {
      this.amrGetApproveInfo(this.user, this.prmonayTuru, null, 0);
    }
    this.personelInfo = [];
    this.personelInfo = [];
    this.usrSelection = [];
    this.mainScreenVisible = true;
  }

  openFlow(flowIndex: any, approve: any) {
    this.mainScreenVisible = false;
    this.getUsers(this.user);
  }

  getFormTemplateTotal(flowIndex: any) {
    let response: any = [];
    let obj: any;
    var keepGoing = false;
    this.responseTotalList = "";
    var say = 0;
    this.aprDataSource.data.forEach(async (element: any) => {
      if (flowIndex === 1)
        obj = {
          user: element.prsicil,
          type: this.flowIndex,
          reason: element.neden.split("-", 1)[0],
          begindate: element.bastarih,
          enddate: element.bittarih,
          startdate: element.isbasitarih,
          days: element.gun,
          desc: element.sebep,
          approver: this.approver,
          begintime: element.bassaat,
          endtime: element.bitsaat,
        };
      else if (flowIndex === 2)
        obj = {
          user: element.prsicil,
          type: this.flowIndex,
          reason: element.neden.split("-", 1)[0],
          begindate: element.bastarih,
          enddate: element.bastarih,
          startdate: element.bastarih,
          days: 1,
          desc: element.sebep,
          approver: this.approver,
          begintime: element.bassaat,
          endtime: element.bitsaat,
        };
      else if (flowIndex === 3)
        obj = {
          user: element.prsicil,
          type: this.flowIndex,
          reason: element.neden.split("-", 1)[0],
          begindate: element.bastarih,
          enddate: element.bastarih,
          startdate: element.bastarih,
          days: 1,
          desc: element.sebep,
          approver: this.approver,
          begintime: element.bassaat,
          endtime: element.bitsaat,
          time: element.sure,
        };
      else
        obj = {
          user: element.prsicil,
          type: this.flowIndex,
          reason: "0",
          begindate: element.bastarih,
          enddate: element.bastarih,
          startdate: element.bastarih,
          days: 1,
          desc: element.sebep,
          approver: this.approver,
          begintime: element.bassaat,
          endtime: element.bitsaat,
        };

      // this.responseTotalList += "<p  style='page-break-after: always;'>" + res.template + "</p>";
      this.PoolService.getTemplate(obj).subscribe(
        (res: any) => {
          if (say > 0)
            response +=
              "<p  style='page-break-after: always;'>" +
              res.template +
              "<footer class='footer'>F01.P17 Rev03</footer></p>";
          else response += res.template;
          say++;
          if (say === this.aprDataSource.data.length) keepGoing = true;
          if (keepGoing) {
            const dialogRef = this.dialog.open(FormLayout, {
              height: "1440px",
              width: "1095px",
              data: {
                html: response,
              },
            });
          }

          this.formOnay = true;
        },
        (err) => {
          console.log(err);
        },
      );
    });
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  // selector: 'dialog-overview-example-dialog',
  templateUrl: "./formlayout-dialog.html",
  // styleUrls: ["./formlayout-dialog.css"]
  styleUrls: ["./outofoffice.component.scss"],
})
export class FormLayout implements OnInit {
  // htmlSnippet: string = "<script type='text/javascript'> setTimeout(function () { window.print() }, 3000);</script>";
  // @ViewChild('element', { static: true }) public viewElement: ElementRef;

  public element: any;
  constructor(
    public renderer: Renderer2,
    private sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<FormLayout>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,

    // @Inject(Document) private _document: Document
  ) {}

  ngOnInit() {
    this.dialogRef.keydownEvents().subscribe((event) => {
      if (event.key === "Escape") {
        this.closeDialog();
      }
    });

    this.dialogRef.backdropClick().subscribe((event) => {
      this.closeDialog();
    });
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // <<<---using ()=> syntax
      const printContent = document.getElementById("print-section");
      const WindowPrt = window.open(
        "",
        "",
        "left=0,top=0,width=900,height=900,toolbar=0,scrollbars=0,status=0",
      );
      if (printContent && WindowPrt) {
        WindowPrt.document.write(printContent.innerHTML);
        WindowPrt.focus();
        WindowPrt.print();
        WindowPrt.document.close();
        WindowPrt.close();
      }
    }, 1000);
  }

  closeDialog() {
    this.dialogRef.close(this.data);
  }

  public appendHTMLSnippetToDOM() {
    // console.log(this.viewElement);
    //  this.element = this.viewElement.nativeElement;
    //  const fragment = document.createRange().createContextualFragment(this.htmlSnippet);
    // this.element.appendChild(fragment);
  }

  // ApproveClick(t) {
  //   this.data.approve = true;
  //   this.data.desc = t.value;
  //   this.dialogRef.close(this.data);
  // }
}

@Component({
  templateUrl: "./approve-dialog.html",
  styleUrls: ["./approve-dialog.scss"],
})
export class DialogApprove {
  constructor(
    public dialogRef: MatDialogRef<DialogApprove>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  InsertClick() {
    this.data.insert = true;
    this.dialogRef.close(this.data);
  }

  ApproveClick() {
    this.data.approve = true;
    this.dialogRef.close(this.data);
  }
}

@Component({
  // tslint:disable-next-line:component-selector
  // selector: 'dialog-overview-example-dialog',
  templateUrl: "./reject-dialog.html",
  styleUrls: ["./reject-dialog.scss"],
})

// tslint:disable-next-line:component-class-suffix
export class RejectApprove {
  // @Input() parentApi: ParentComponentApi
  constructor(
    public dialogRef: MatDialogRef<RejectApprove>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
  ) {}

  ApproveClick(t: any) {
    this.data.approve = true;
    this.data.desc = t.value;
    this.dialogRef.close(this.data);
  }
}
